// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config
  };
};

class PrintSettings extends React.Component {
  constructor(props) {
    super(props);

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  // #endregion
  render() {
    const { config } = this.props;

    const printMode =
      (config.setting == 2 || config.setting == 3) && config.printable ? (
        <React.Fragment>
          <Label for="printMode" className="ml-2" sm={2}>
            Print mode
          </Label>
          <Col>
            <Input
              value={config.printMode}
              className="ml-2"
              sm={2}
              type="select"
              name="printMode"
              className="dropdown-black"
              id="printMode"
              onChange={this.handleChange}
              required={
                (config.setting == 2 || config.setting == 3) &&
                config.printable == "true"
              }
            >
              <option value="" selected={!config.printMode} disabled>
                -- Select print mode --
              </option>
              <option value="2x2">2x2</option>
              <option value="4x1">4x1</option>
            </Input>
          </Col>
        </React.Fragment>
      ) : null;

    const printable = config.printable ? (
      <Input
        checked
        type="checkbox"
        name="printable"
        id="printable"
        onChange={this.handleCheckboxChange}
      />
    ) : (
      <Input
        type="checkbox"
        name="printable"
        id="printable"
        onChange={this.handleCheckboxChange}
      />
    );

    const paperSize = config.printable ? (
      <React.Fragment>
        <Label for="paperSize" sm={2}>
          Paper size
        </Label>
        <Col>
          <Input
            value={config.paperSize}
            sm={2}
            type="select"
            name="paperSize"
            id="paperSize"
            className="dropdown-black"
            onChange={this.handleChange}
            required={config.printable}
          >
            <option value="" selected={!config.paperSize} disabled>
              -- Select paper size --
            </option>
            <option value="6x4">6x4 (DSP-620) </option>
            <option value="5x7">5x7 (BRAVA21) </option>
            <option value="4x6">4x6 (BRAVA21) </option>
            <option value="6x8">6x8 (BRAVA21) </option>
          </Input>
        </Col>
      </React.Fragment>
    ) : null;

    return (
      <Section title="Print settings">
        <FormGroup row className="d-flex justify-content-center">
          <Label for="printable" className="ml-2" sm={2}>
            <Col>
              {printable}
              Printable
            </Col>
          </Label>
        </FormGroup>
        <FormGroup row className="d-flex justify-content-center">
          {printMode}

          {paperSize}
        </FormGroup>
      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/PrintSettings.jsx